import * as Constantes from '../../../shared/constants';

// Módulos
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

// Interfaces y Modelos  
import { IArtPreparacion } from 'src/app/interfaces/artPreparacion';
import { ICliente } from 'src/app/interfaces/cliente';
import { ICampanya } from 'src/app/interfaces/campanya';
import { IApiResp } from 'src/app/interfaces/api-resp';

// Servicios 
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { PreparacionesService } from 'src/app/services/datos/preparaciones.service';

// Librerías
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import FuncLib from 'src/app/providers/funcionesLib';
import { EanLabelsService } from 'src/app/services/ean-labels.service';
import { ModalRecogidaService } from 'src/app/services/modal-recogida.service';

@Component({
  selector: 'app-preparacion-new',
  templateUrl: './preparacion-new.component.html',
  styleUrls: ['./preparacion-new.component.scss']
})
export class PreparacionNewComponent implements OnInit, OnDestroy {

  //Usar constantes en el template
  Constantes = Constantes;

  // Librería de funciones
  public funcLib: FuncLib = new FuncLib();

  id_campanya: string = '';

  public campForm: FormGroup = new FormGroup({});
  public enviado: boolean = false;
  public loading: boolean = false;

  // Intervalo de refresco de la tabla
  refreshInterval: any;
  timeRefreshCampanyas: number = environment.timeRefreshCampanyas;
  progressPercentage: number = 0;

  public fotoDir: string = environment.fotoDir;

  public lista: IArtPreparacion[] = [];
  public userList: any[] = [];
  public campanyaInfo: ICampanya = {};
  public clienteInfo: ICliente = {};
  private totales: any = {};

  selected: any = [];
  public totSelCantidad: number = 0;
  public totSelUbicaciones: number = 0;

  public cajasRecogidas: any[] = [];

  SelectionType = SelectionType;
  selectAllRows: boolean = false;
  selectNoAssigned: boolean = false;

  public rows: any = [];
  public temp: any[] = [];

  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';
  public summaryPosition: string = localStorage.getItem('summaryPosition') || 'bottom';
  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  alturasList: string[] = [];
  public altura: string = '*';

  pasillosList: string[] = [];
  public pasillo: string = '*';




  textoDestacado: string = '';

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: `total`,
    selectedMessage: `seleccionados`
  }

  ColumnMode = ColumnMode;
  @ViewChild(PreparacionNewComponent) table: PreparacionNewComponent | any;

  constructor(
    private router: Router,
    private fb: FormBuilder,

    private prepSrv: PreparacionesService,
    private usuarioSrv: UsuarioService,
    private prepracionSrv: PreparacionesService,
    private notificacionesSrv: NotificacionesService,
    private activatedRoute: ActivatedRoute,
    public eanLabelsSrv: EanLabelsService,
    public modalrecogidaSrv: ModalRecogidaService,

  ) {
    // Definir formulario 
    this.campForm = this.fb.group({
      id_usuario: ['', Validators.required],
    })
  }

  ngOnInit(): void {
    // Suscribirse a los parámetros de la url, si envían una id, cargar los artículos de la campanya
    this.activatedRoute.params.subscribe(({ id }) => {
      this.id_campanya = id;
      // this.cargaArticulosList();
      this.cargaPreparacionesList();
    })

    // Configurar un intervalo para refrescar datos auomáticamente
    this.resetRefreshInterval();

    // Suscribirse al cierre del modal de recogida para refrescar datos
    this.modalrecogidaSrv.cerrarModalSubject.subscribe(() => {
      this.refreshData();
    });

  }

  ngOnDestroy(): void {
    // Limpiar el intervalo cuando el componente se destruya
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }


  cargaPreparacionesList() {
    this.lista = [];
    this.loading = true;
    this.prepSrv.getPreparacionPorCampanya(Number(this.id_campanya))
      .subscribe(resp => {
        this.loading = false;

        console.log('__cargaPreparacionesList', resp);

        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje);
          if (resp.mensaje == 'Campaña no encontrada') this.router.navigate(['/panel/campanyas_lista'])
        } else {
          this.lista = resp.data;
          this.campanyaInfo = resp.totales.campanya;
          this.clienteInfo = resp.totales.cliente;
          this.totales = resp.totales;
        }


        if (resp.totales && resp.totales.existeAnterior) {
          this.notificacionesSrv.aviso('warning', 'ATENCIÓN, Para este cliente existen campañas anteriores a esta en estado pendiente ó parcialmente asignadas');
        }

        this.rows = this.lista;
        this.temp = [...this.lista];

        this.cargaAlturasList();
        this.cargaPasillosList();
        this.cargaUsuariosList();
      })

  }

  muestraCajasRecogidas(row: any) {
    this.cajasRecogidas = [];
    console.log('__getPrepCajas dataIn', row);

    this.loading = true;
    this.prepSrv.getPrepCajas(row.recogida_cod).subscribe(resp => {
      this.loading = false;
      console.log('__getPrepCajas resp', resp);
      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }
      this.cajasRecogidas = resp.data.map((rec: any) => ({ ...rec, estado: row.estado }));
      console.log('__cajasRecogidas', this.cajasRecogidas);


      if (!this.cajasRecogidas.length) {
        this.notificacionesSrv.aviso('info', 'No se han encontrado recogidas en cajas para este código de recogida');
      }
    });
  }

  delCajaRecogida(rec: any) {
    console.log('__delCajaRecogida rec', rec);

    if (rec.estado === Constantes.ESTADO_PREPARACION_COMPLETADA) {
      this.notificacionesSrv.aviso('warning', `Ya está completa la recogida. No puedes modificar esta recogida`);
      return;
    }
    Swal.fire({
      title: '¿Estás seguro?',
      html: `Recogida ${rec.recogida_cod}, vas a eliminar la recogida de <b>${rec.cajas}</b> cajas del artículo <b>${rec.ean}</b>.<br> Este quedará con <b>${rec.cajas * rec.cant_cajas_unidades}</b> unidades menos que se devolverán a Stock en la ubicación original`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.prepSrv.delPrepCaja(rec.id).subscribe(resp => {
          this.loading = false;
          if (resp.error) {
            this.notificacionesSrv.aviso('error', resp.mensaje);
          } else {
            this.notificacionesSrv.aviso('success', resp.mensaje);
            // Recargar datos para actualizar la tabla de cajas y la principal
            this.muestraCajasRecogidas({ recogida_cod: rec.recogida_cod });
            this.refreshData();
          }
        });
      }
    });
  }


  // Refrescar los datos de la tabla
  refreshData() {
    this.cargaPreparacionesList()
    this.cancelarSelecctedClick() // Desmarcar checks de seleccion
    this.pasillo = '*';
    this.altura = '*';
    this.textoDestacado = '';

    // Reiniciar el tiempo de refreshInterval
    this.resetRefreshInterval();
  }

  // Refrescar los datos de la tabla automáticamente solo se ejecutará si NO se ha seleccionado ninguna preparación
  refreshDataAuto() {
    if (!this.selected.length) {
      this.refreshData()
    }
  }

  // Re-inicializar el intervalo de refresco
  resetRefreshInterval() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    this.progressPercentage = 0;
    const tickTime = 1000; // actualiza cada segundo
    this.refreshInterval = setInterval(() => {
      this.progressPercentage += (100 / (this.timeRefreshCampanyas / tickTime));
      if (this.progressPercentage >= 100) {
        this.progressPercentage = 0;
        this.refreshDataAuto();
      }
    }, tickTime);
  }

  // Detener el intervalo de refresco
  stopRefreshInterval() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
    this.progressPercentage = 0;
  }

  cargaUsuariosList() {
    this.userList = []
    const params = {
      id_almacen: this.clienteInfo.alm_por_defecto,
      rol: 'usuario'
    }

    this.usuarioSrv.getUsrListRol(params).subscribe(resp => {
      this.loading = false;
      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
      } else {
        this.userList = resp.data;
      }

      console.log('__cargaUsuariosList', resp);
    })
  }



  cargaPasillosList() {
    this.lista.forEach(item => {
      const ubicacion = item.ubicacion;
      if (ubicacion && ubicacion.length >= 8) {
        const ubiPas = ubicacion.substr(2, 2);

        if (!this.pasillosList.includes(ubiPas)) {
          this.pasillosList.push(ubiPas);
        }
      }
    });
    this.pasillosList.sort();
  }

  cargaAlturasList() {
    this.lista.forEach(item => {
      const ubicacion = item.ubicacion;
      if (ubicacion && ubicacion.length >= 8) {
        const ubiAlt = ubicacion.substr(6, 2);

        if (!this.alturasList.includes(ubiAlt)) {
          this.alturasList.push(ubiAlt);
        }
      }
    });
    this.alturasList.sort();
  }


  enviar() {
    this.enviado = true;
    console.log(this.campForm);

    if (this.campForm.invalid) {
      console.log("ERRORES:", this.campForm);
      return;
    }

    // validar si existen lotes diferentes para un mismo artículo
    if (!this.validarLotes()) {
      this.notificacionesSrv.aviso('error', 'Has seleccionado ubicaciones con el mismo artículo y diferente lote')
      return;
    }

    // Todo ok, enviar al BackEnd 
    const datos = {
      ...this.campForm.value,
      selected: this.selected,
      fecha_entrada: new Date(),
      campanyaInfo: this.campanyaInfo
    }

    console.log("_datos=", datos);

    this.loading = true;
    this.prepSrv.asignaUsr(datos).subscribe((resp: IApiResp) => {
      this.loading = false;

      console.log(resp);

      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        // for (let controlName in resp.mensaje) {
        //   this.campForm.get(controlName)!.setErrors({ 'apiError': resp.mensaje[controlName] });
        // }
      } else {
        this.notificacionesSrv.aviso('success', resp.mensaje);
        // this.router.navigateByUrl(`panel/campanyas_lista`);
        this.selected = [];
        this.cargaPreparacionesList();
        return
      }
    })
  }

  // AUX  //

  cancelarSelecctedClick() {
    this.selectAllRows = false;
    this.selectNoAssigned = false;
    this.selected = [];
  }


  get f() {
    return this.campForm.controls;
  }


  // Buscar Stock alternativo
  buscaStock(row: any) {
    console.log('__buscaStock row=', row)
    console.log('__buscaStock this.totales=', this.totales)
    const preparacion: any = row;

    // Si se ha empezado a repartir, no se puede buscar stock alternativo
    if (this.totales.total_cant_repartida > 0) {
      Swal.fire({
        text: `NO puedes buscar stock alternativo, ya se ha empezado a preparar esta recogida`,
        icon: 'warning'
      });
      return;
    }

    // Llamar al servicio para buscar nueva ubicación con el motivo
    preparacion.saltar = 'Sin Stock';
    this.loading = true;
    this.prepracionSrv.buscaUbiAlternativa(preparacion).subscribe(async resp => {
      this.loading = false;
      console.log('__buscaUbicacionAlternativa()', resp);

      if (resp.error) {
        this.notificacionesSrv.aviso('error', resp.mensaje);
        return;
      }
      if (resp.totales && resp.totales.salidaTipo === 'B') {
        this.notificacionesSrv.aviso('warning', resp.mensaje);

        await this.deletePreparacion(preparacion.id);

        // this.loading = true;
        // this.prepracionSrv.delete(preparacion.id)
        //   .subscribe(async resp => {
        //     this.loading = false;
        //     console.log(`__ this.prepracionSrv.delete(${preparacion.id})`, resp);
        //   });

      }
      if (resp.totales && resp.totales.salidaTipo === 'C') {
        this.notificacionesSrv.aviso('success', resp.mensaje);

        await this.deletePreparacion(preparacion.id);

        // this.loading = true;
        // this.prepracionSrv.delete(preparacion.id)
        //   .subscribe(async resp => {
        //     this.loading = false;
        //     console.log(`__ this.prepracionSrv.delete(${preparacion.id})`, resp);
        //   });

      }

      // Cargar las nuevas preparaciones
      this.cargaPreparacionesList();

    });

  }

  async deletePreparacion(id: number): Promise<void> {
    this.loading = true;
    try {
      const resp = await this.prepracionSrv.delete(id).toPromise();
      console.log(`__ this.prepracionSrv.delete(${id})`, resp);
    } catch (error) {
      console.error('__Error al eliminar preparación', error);
    } finally {
      this.loading = false;
    }
  }


  // Modificar valores de la recogida, abrir modal
  resetPreparacion(row: any) {

    const recogido = Number(row.cant_recogida);
    const preparado = Number(row.cant_repartida);
    console.log('__resetPreparacion', row)

    // validar si se puede modificar
    if (recogido === 0) {
      this.notificacionesSrv.aviso('warning', 'No se puede modificar una recogida que no ha sido recogida');
      return;
    }
    if (preparado === recogido) {
      this.notificacionesSrv.aviso('warning', `Ya está completa la preparación. No puedes modificar esta recogida`);
      return;
    }
    if (preparado > 0) {
      this.notificacionesSrv.aviso('warning', `Ya se han preparado ${preparado} unidades de esta referencia en esta campaña. No puedes modificar la recogida`);
      return;
    }


    // Todo ok, abrir modal

    this.muestraCajasRecogidas(row);
    if (preparado > 0 && preparado < recogido) {
      this.notificacionesSrv.aviso('info', `Ya se han preparado ${preparado} unidades. Cómo máximo puedes cancelar ${recogido - preparado} unidades de esta recogida`);
    } else {
      this.notificacionesSrv.aviso('success', `RECOGIDO: ${recogido}  - PREPARADO: ${preparado}`);
    }

    // Presentar aviso con Swal antes de abrir el modal
    Swal.fire({
      title: '¡Atención!',
      html: 'Asegúrate de que no haya ninguna recogida o preparación abierta en PDA para esta campaña <b>' + this.campanyaInfo.camp_cod + '</b> antes de continuar.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.isConfirmed) {
        // abrir modal  
        this.modalrecogidaSrv.preparacion = row;
        this.modalrecogidaSrv.abrirModal();
      } else {
        return;
      }
    });

  }


  // Validar que no existan lotes diferentes para un mismo artículo en el array sleccionado
  validarLotes(): boolean {
    const articlesMap = new Map<string, Set<string>>();

    for (const detail of this.selected!) {
      const articleId = String(detail.id_articulo);
      const lote = String(detail.lote);

      if (lote) {

        if (!articlesMap.has(articleId)) {
          articlesMap.set(articleId, new Set());
        }

        const lotesSet = articlesMap.get(articleId);
        if (lotesSet) {
          lotesSet.add(lote);
          if (lotesSet.size > 1) {
            return false; // Encontrado el mismo artículo con diferentes lotes
          }
        }

      }

    }

    return true; // Todos los artículos tienen lotes únicos
  }


  marcarComoAcabada(row: any) {
    Swal.fire({
      title: '¿Estás seguro?',
      html: 'Marcar como acabada la recogida de <b>' + row.cant_recogida + '</b> unidades del EAN <b>' + row.ean + '</b>',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.isConfirmed) {
        const data = {
          id: row.id,
          estado: Constantes.ESTADO_PREPARACION_COMPLETADA
        }
        this.loading = true;
        this.prepSrv.actualizaEstado(data).subscribe(resp => {
          this.loading = false;
          if (resp.error) {
            this.notificacionesSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notificacionesSrv.aviso('success', resp.mensaje);
          this.refreshData();
        });
      } else {
        return;
      }
    });
  }


  //  **  AUX  ** 

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr); // convertir el valor a número
  }

  filtroUbiChange() {
    // Filtrar por pasillo y altura
    const temp = this.temp.filter(item => {
      const ubicacion = item.ubicacion;
      const ubiPas = ubicacion.substr(2, 2);
      const ubiAlt = ubicacion.substr(6, 2);

      const pasilloFiltro = this.pasillo === '*' || ubiPas === this.pasillo;
      const alturaFiltro = this.altura === '*' || ubiAlt === this.altura;

      return pasilloFiltro && alturaFiltro;
    });

    this.rows = temp;
    this.table = this.lista;

    // Reiniciar el tiempo de refreshInterval
    this.resetRefreshInterval();
  }




  buscarTodo(event: any) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some((key: any) =>
        d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );
    this.textoDestacado = txt;
    this.rows = temp;
    this.table = this.lista;

    // Reiniciar el tiempo de refreshInterval
    this.resetRefreshInterval();
  }

  // Exportar a Excel
  exportToExcel(): void {
    const fileName = `recogidas-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }



  public sumaCeldas(cells: any[]) {
    // Devuelve la suma de la columna, formateada y sin decimales
    const filteredCells = cells.filter(cell => !!cell);
    const sum: number = filteredCells.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue), 0);
    // return sum.toLocaleString('es');
    return sum.toLocaleString('de-DE');
  }

  public cuentaCeldas(cells: any[]) {
    // Devuelve el número de filas
    const filteredCells = cells.filter(cell => !!cell);
    const sum: number = filteredCells.reduce((accumulator, currentValue) => accumulator + 1, 0);
    return sum.toLocaleString('de-DE');
  }



  // ** Selección de líneas  ** //

  onActivate(event: any) {

    // Evitar selección en caso de doble click
    if (event.type === 'dblclick') {
      event.rowElement.classList.remove('datatable-row-selected'); // Desmarca la fila

      this.filtraEmpezados()
      this.totalesSelected();
      return;
    }


    if (event.type === 'click') {
      console.log('Activate Evento click', event);
      this.selectAllRows = false;

      this.filtraEmpezados()
      this.totalesSelected();

      console.log('_selected ', this.selected);
    }
  }


  toggleSelectAllRows() {
    // Establecer todos los elementos como seleccionados?
    this.selectNoAssigned = false;
    const allRows = [...this.rows];

    if (this.selectAllRows) this.selected = [...allRows];
    if (!this.selectAllRows) this.selected = [];

    this.filtraEmpezados();
    this.totalesSelected();
  }


  modifPreparacion(row: any) {
    console.log('__modifPreparacion', row);
  }


  toggleNoAssigned() {

    console.log('__this.rows', this.rows);


    // Filtrar las filas donde usr_asignado es NULL
    const noAssignedRows = this.rows.filter((r: { usr_asignado: null; }) => r.usr_asignado === null);

    if (this.selectNoAssigned) {
      // Si está seleccionando, agrega las filas no asignadas a las seleccionadas
      this.selected = [...this.selected, ...noAssignedRows];
    } else {
      // Si no está seleccionando, filtra las filas no asignadas de las seleccionadas
      this.selected = this.selected.filter((r: any) => !noAssignedRows.includes(r));
    }

    this.filtraEmpezados();
    this.totalesSelected();
  }


  filtraEmpezados() {
    // No seleccionar los ya empezados
    this.selected = this.selected.filter(
      (item: { estado: number }) => item.estado == 1
    );
  }

  totalesSelected() {
    // Calcula los totales sobre los seleccionados
    this.totSelCantidad = this.selected.reduce((total: number, obj: { cant_reserva: string; }) => total + parseInt(obj.cant_reserva), 0);
    this.totSelUbicaciones = this.selected.reduce((total: number, obj: { totUbicaciones: string; }) => total + parseInt(obj.totUbicaciones), 0);
  }

  // ** Totales de cajas recogidas ** //
  get totCajas(): number {
    return this.cajasRecogidas.reduce((sum, rec) => sum + (Number(rec.cajas) || 0), 0);
  }

  get totCantidadCajas(): number {
    return this.cajasRecogidas.reduce((sum, rec) => sum + ((Number(rec.cajas) || 0) * (Number(rec.cant_cajas_unidades) || 0)), 0);
  }

}
